'use client';

import * as React from 'react';
import { onAuthStateChanged, type User } from 'firebase/auth';
import { auth } from '@/lib/firebase';

/**
 * Shared Firebase auth subscription. Returns `undefined` while the initial
 * auth state is still resolving, then `User | null`. Use this instead of
 * hand-rolling an onAuthStateChanged effect per component.
 */
export function useAuthUser(): User | null | undefined {
  const [user, setUser] = React.useState<User | null | undefined>(undefined);
  React.useEffect(() => onAuthStateChanged(auth, setUser), []);
  return user;
}
